<template>
  <div>
        <spinner  v-if="flagRuleIsLoading"></spinner>
        <div v-else class="block-content">

        <div v-if = "sharingTransmittedFlag" class="col-sm-12 col-md-12">
          <div class="col-sm-12 col-md-12 align-center">
            <i class="fa fa-check align-center fa-3x"></i>
          </div>
          <h3 class="font-w300 align-center push-10">{{textSharingTransmitted[actualLanguage]}}</h3>
          <h5 class="font-w300 align-center push-10">{{textSharingTransmitted2[actualLanguage]}}</h5>
          
          
        </div>
        <div v-else class="col-sm-12 col-md-12">
          <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
              <h2 class="font-w300 push-10 align-center"><i class="fa fa-share-alt fa-1x push-15-r "></i>{{overlayParameters.modalTitle[actualLanguage]}}</h2>
  
              <h4 class="font-w300 push-10 align-center">{{overlayParameters.entityReferenceName}}</h4>

              <div v-if="overlayParameters.displayUserOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-user push-5-r"></i>{{labelSectionUser[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.user" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.user[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>

              <div v-if="overlayParameters.displayGroupOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-users push-5-r"></i>{{labelSectionGroup[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.group" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.group[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>

              <div v-if="overlayParameters.displayBundleOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-usb push-5-r"></i>{{labelSectionBundle[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.bundle" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.bundle[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>


              <div v-if="overlayParameters.displayDeviceOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-server push-5-r"></i>{{labelSectionDevice[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.device" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.device[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>


              <div v-if="overlayParameters.displayChannelOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-television push-5-r"></i>{{labelSectionChannel[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.channel" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.channel[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>

              <div v-if="overlayParameters.displayAlertOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-bell push-5-r"></i>{{labelSectionAlert[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.alert" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.alert[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>

               <div v-if="overlayParameters.displayCarOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-car push-5-r"></i>{{labelSectionCar[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.car" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.car[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>             

              <div class="form-group">
                <div class="col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6">
                    <div class="col-sm-12">
                      <label for="register4-firstname">{{labelUserRecipient[actualLanguage]}}</label>
                    </div>
                    <div class="col-sm-12">
                      {{textDescriptionToDo[actualLanguage]}}
                    </div>
                      
                  </div>
                  <div class="col-xs-12 col-sm-6">
                      <input class="form-control" @change="validateUserExist()" type="text" v-model="sharingUserRecipient" placeholder="courriel / email">
                  </div>
                  
                </div>
              </div>


              <div v-if="userExistsFlag" class="form-group">

                  <div class="col-sm-12 col-md-12">
                    <div class="col-xs-12 col-sm-6">
                        <label for="register4-firstname">{{labelReferenceName[actualLanguage]}}</label>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <input class="form-control" type="text" v-model="sharingReferenceName" placeholder="Reference">
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-12 push">
                    <div class="col-xs-12 col-sm-6">
                        <label for="register4-firstname">{{labelMessage[actualLanguage]}}</label>
                    </div>
                    <div class="col-xs-12">
                        <textarea class="form-control" v-model="sharingMessage" rows="2" placeholder="Message"></textarea>
                    </div>
                  </div>


                  <div class="col-sm-12 col-md-12">
                    <div>
                        <p><button @click="saveNewSharing()" type="button" class="btn btn-block btn-success" name="button">
                          <spinner size="small" v-if="commentIsSaving"></spinner>
                          <span v-else><i class="fa fa-share-alt fa-1x push-5-r "></i>{{labelButtonShare[actualLanguage]}}</span></button></p>
                    </div> 
                  </div>

              </div>
            </form>

          </div>
        </div>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from './Spinner.vue'
import _ from 'underscore'
export default {
  name: 'ConfigAccessRulesForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      flagRuleIsLoading : true,
      commentIsSaving: false,
      userExistsFlag:false,
      sharingTransmittedFlag:false,
      sharingRuleTemplateVersion:process.env.VAR_ACCESS_RULE_TEMPLATE,
      description : '',
      channelIndex : 0,
      workTime : 0,
      sharingReferenceName : '',
      sharingMessage : '',
      ruleTemplate : {},
      sharingUserRecipient : '',


      actualLanguage : "FR",
      labelSectionUser: {FR: 'Accès usager', EN: 'User access'},
      labelSectionGroup: {FR: 'Groupe', EN: 'Group'},
      labelSectionBundle: {FR: 'Systèmes', EN: 'Systems'},
      labelSectionDevice: {FR: 'Modules', EN: 'Modules'},
      labelSectionChannel: {FR: 'Appareils', EN: 'Device'},
      labelSectionAlert: {FR: 'Alerte', EN: 'Alerts'},
      labelSectionCar: {FR: 'VE ou Borne de recharge', EN: 'EV or EVSE'},

      textSharingTransmitted: {FR: 'Le partage a été transmit avec succès!', EN: 'Sharing was successfully transmitted!'},
      textSharingTransmitted2: {FR: 'Vous pouvez fermer cette fenêtre.', EN: 'You can close this window.'},

      labelUserRecipient:{FR: 'Destinataire du partage (courriel)', EN: 'Sharing recipient user (email)'},
      textDescriptionToDo:{FR: "Entrez le courriel du destinataire du partage et appuyer sur ENTRÉ pour valider son enregistrement dans le système.", EN: 'Enter the sharing recipient email and press ENTER to validate if this user exits in the system.'},
      labelReferenceName:{FR: 'Identifiant de partage', EN: 'Sharing identifier'},
      labelMessage:{FR: 'Message au destinataire', EN: 'Sharing recipient message'},
      labelButtonCheckUserExist: {FR: "Vérifier si l'usager existe dans le système", EN: 'Verify if the user exist in the system'},
      labelButtonShare: {FR: "Transmettre l'invitation de partage", EN: 'Transmit the sharing invitation'},
    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle','actualGroup']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  methods: {

    loadRuleTemplate() {
        var requestData = { 'postAction':'GetRuleTemplate',
                            'ruleVersion': this.sharingRuleTemplateVersion,
                            }
        this.$store.dispatch('sessionStore/postRule', requestData)
            .then((response) => {
              console.log(response.data)
            if(response.data.Code=='OK'){
                console.log(response.data)
                this.ruleTemplate = response.data.Template
                this.flagRuleIsLoading = false
                }
                else{ window.alert("L'enregistrement a échoué. / Saving fail." )}
            })
    },

  toUsername(email) {
    var email2 = email.replace('.', '-dot-')
    email = email2.replace('.', '-dot-')
    email2 = email.replace('.', '-dot-')
    return email2.replace('@', '-at-')
  },


  validateUserExist(){
      return this.$store.dispatch('sessionStore/validateUserExist',this.sharingUserRecipient)
      .then((response) => {
         this.displayMessage = response.data.Message
         if (response.data.Code=='Fail'&& this.actualLanguage == "FR") window.alert('Erreur de validation !')
         if (response.data.Code=='Fail'&& this.actualLanguage == "EN") window.alert('Validation error !')

         if (response.data.Code=='E01' && this.actualLanguage == "FR") window.alert("L'utilisateur n'existe pas dans le system EV Sens!")
         if (response.data.Code=='E01' && this.actualLanguage == "EN") window.alert("User don't exists in the EV Sens system")
         this.userExistsFlag = false

         if (response.data.Code=='OK') {
              this.userExistsFlag = true
           }
        })
  },


    saveNewSharing() {
        this.commentIsSaving = true
        //console.log(this.overlayParameters)
        var requestData = { 'postAction':'SaveNewSharing',
                            'guessProfileId':this.toUsername(this.sharingUserRecipient),
                            'groupId': this.actualGroup.group_id,
                            'bundleId': this.actualBundle.bundle_id,
                            
                            'sharingInfo':{'referenceName':this.sharingReferenceName,
                                           'sharingMessage':this.sharingMessage},
                            'entityOwner':this.overlayParameters.entityOwner,
                            'sharedEntity': {'entityType':this.overlayParameters.sharingType,
                                             'entityId':this.overlayParameters.entityId,
                                             'entityReferenceName':this.overlayParameters.entityReferenceName},
                            'ruleTemplateVersion':this.sharingRuleTemplateVersion,
                            'permissions':this.ruleTemplate.permissions
                            }
        //console.log(requestData)

        this.$store.dispatch('sessionStore/postRule', requestData)
            .then((response) => {
              //console.log(response.data)
              this.commentIsSaving = false
            if(response.data.Code=='OK'){
                this.sharingTransmittedFlag = true
                }
                else{ 
                  window.alert(response.data.Message[this.actualLanguage])}
            })       
      
    },
  },


  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //this.channelIndex = localStorage.actualChannelIndex
    this.channelIndex = this.overlayParameters.channelIndex

    this.loadRuleTemplate()

  }


}
</script>



// WEBPACK FOOTER //
// ConfigAccessRulesForm.vue?81641c68